import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-auth-logout',
  templateUrl: './auth-logout.component.html',
  styleUrls: ['./auth-logout.component.scss']
})
export class AuthLogoutComponent implements OnInit {

  signedOut = false;
  error = false;

  constructor(private authService: AuthenticationService, private route: ActivatedRoute, private changes: ChangeDetectorRef) { }

  async ngOnInit(): Promise<void> {
    try {
      if (this.route.snapshot.routeConfig?.path === 'signout-callback-oidc') {
        await this.authService.completeLogout();
        this.signedOut = true;
      } else if (this.route.snapshot.routeConfig?.path === 'signed-out') {
        await this.authService.clearSession(false);
        this.signedOut = true;
      } else if (window.self !== window.top) {
        await this.authService.frontChannelLogout();
        this.signedOut = true;
      } else {
        await this.authService.logout();
      }
    } catch {
      this.error = true;
    } finally {
      this.changes.markForCheck();
    }
  }

  signIn(): void {
    void this.authService.login().catch(() => {
      this.error = true;
      this.changes.markForCheck();
    });
  }

}
